import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, Sgkz002dComponent, LoginComponent, BrowserBackGuard, Sgkz006dComponent, InitialInfoResolverService, Sgkz007dComponent } from 'cbc-shared-lib';
import { MainComponent } from './pages/main/main.component';

const routes: Routes = [
  // 認証の都合で空のパスをLoginへ
  { path: '', component: LoginComponent, canDeactivate: [BrowserBackGuard] },
  { path: 'login', component: LoginComponent, canDeactivate: [BrowserBackGuard] },
  { path: 'sgkz002d', component: Sgkz002dComponent, canDeactivate: [BrowserBackGuard] },
  { path: 'sgkz007d', component: Sgkz007dComponent, canDeactivate: [BrowserBackGuard] },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    canDeactivate: [BrowserBackGuard],
    children: [
      { path: '', redirectTo: 'sgkz001d', pathMatch: 'full' },
      { path: '', loadChildren: () => import('sg-features').then(m => m.CisCommonModule) },
      { path: 'sgkc', loadChildren: () => import('sg-features').then(m => m.SgKcMainModule), canActivate: [] },
      { path: 'sgkb', loadChildren: () => import('sg-features').then(m => m.SgKbMainModule), canActivate: [] },
      { path: 'sgkd', loadChildren: () => import('sg-features').then(m => m.SgKdMainModule), canActivate: [] },
      { path: 'sgke', loadChildren: () => import('sg-features').then(m => m.SgKeMainModule), canActivate: [] },
      { path: 'sgkz006d', component: Sgkz006dComponent, canDeactivate: [BrowserBackGuard] },
    ],
    resolve: {
      item: InitialInfoResolverService
    }
  },
];

/**
 * ルートルーティングモジュール
 * @export
 * @class AppRoutingModule
 */
@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
